export default __webpack_public_path__ + "static/media/m2020logo.b9d6e211.png";